import React, { useState, useRef, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode } from 'primereact/api';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import { Toast } from 'primereact/toast';
import { saveAs } from 'file-saver';
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setPageData } from "store/actions";
import CompanySelector from "ATSComponents/Common/CompanySelector";
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer";

const MyPipelineReport = () => {
     const { first, rows,totalRecords } = useSelector((state) => state.calendar.pagination);
      const dispatch = useDispatch();

    const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
    const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
    const [companyId, setCompanyId] = useState(intialcompanyId);

    const handleCompanyChange = (company) => {
        if (company?.company_id) {
            const selectedId = company.company_id;
            setCompanyId(selectedId);

            const page = Math.floor(first / rows) + 1;
            // fetchMyPipelineReports(page, selectedId);
        }
    };

    // const [pageState, setPageState] = useState({ first: 0, rows: 10 });
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        candidate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        job_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
        type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        userid: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
    });
    document.title = "ATS - Reports"

    const[reports,setReports] = useState([])

    const [selectedReports, setSelectedReports] = useState([]);
    const dt = useRef(null);
    const toast = useRef(null);

    const onSelectionChange = (e) => {
        setSelectedReports(e.value);
    };

    // const fetchMyPipelineReports = async(page)=>{
    //     try{
    //         const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/report/pipeline_report/?page=${page}&size=${rows}`)
    const fetchMyPipelineReports = async (page, companyId) => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/report/pipeline_report/?page=${page}&size=${rows}&company_id=${companyId}`);
            const apiResponse = response?.data?.results
            const transformedData = apiResponse.map((item)=>{
            let formattedDateTime = '';

    if (item?.created_at) {
        const date = new Date(item.created_at);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
    }
                return{
                    candidate:item?.candidate_name,
                    job_id:item?.job_number,
                    job_title:item?.job_title,
                    type:item?.employment_type,
                    date_time:formattedDateTime,
                    userid:item?.hiring_manager,
                    job_candidate_id:item?.job_candidate_id
                }
            })
            setLoading(false);
            setReports(transformedData)
            dispatch(setPageData({
                first:(page-1)*rows,
                rows:rows,
                totalRecords:response?.data?.count || 0
            }))
        }
        catch(error){
            console.log('error',error.message)
            setLoading(false);
        }
    }


    // useEffect(()=>{
    //     const page = Math.floor(first / rows) + 1;
    //     fetchMyPipelineReports(page)
    // },[first,rows])

    useEffect(() => {
        if (companyId) {
            const page = Math.floor(first / rows) + 1;
            fetchMyPipelineReports(page, companyId);
        }
    }, [first, rows, companyId]);

    const onPage = (e) => {
        const newPage = Math.floor(e.first / e.rows) + 1;
        dispatch(setPageData({
          first: e.first,
          rows: e.rows,
          totalRecords,
        }));
        // fetchMyPipelineReports(newPage , companyId)
      };

    const exportCSV = () => {
        dt.current.exportCSV({ selectionOnly: selectedReports.length > 0 });
        if (selectedReports.length === 0 && toast.current) {
            toast.current.show({
                severity: 'info',
                summary: 'Info',
                detail: 'No rows selected, exporting all data.',
                life: 3000
            });
        }
    };

const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
        import("jspdf-autotable").then(() => {
            const doc = new jsPDF.default("landscape");
            const dataToExport = selectedReports.length > 0 ? selectedReports : reports;

            if (dataToExport.length === 0) {
                toast.current.show({
                    severity: "info",
                    summary: "Info",
                    detail: "No rows selected, exporting all data to PDF.",
                    life: 3000,
                });
            }

            const exportColumns = [
                { title: "Candidate", dataKey: "candidate" },
                { title: "Job ID", dataKey: "job_id" },
                { title: "Job Title", dataKey: "job_title" },
                { title: "Type", dataKey: "type" },
                { title: "Date & Time", dataKey: "date_time" },
                { title: "Recruiter Name", dataKey: "userid" }
            ];

            const formattedData = dataToExport.map(item => {
                const row = {};
                exportColumns.forEach(col => {
                    row[col.dataKey] = item[col.dataKey] ?? '';
                });
                return row;
            });

            doc.autoTable({
                columns: exportColumns,
                body: formattedData.length > 0 ? formattedData : [{ candidate: "No data to export" }],
                startY: 20,
                styles: { fontSize: 8, cellPadding: 2 },
                theme: "grid",
                margin: { top: 10, left: 5, right: 5 },
                columnStyles: { 0: { cellWidth: 30 } },
            });

            doc.save("pipeline_report.pdf");
        }).catch((error) => {
            console.error('Error exporting to PDF:', error);
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'An error occurred while exporting to PDF.',
                    life: 4000
                });
            }
        });
    });
};

    const exportExcel = () => {
        import('xlsx').then((xlsx) => {
            const dataToExport = selectedReports.length > 0 ? selectedReports : reports;
            const formattedData = dataToExport.map(report => ({
                Candidate: report.candidate,
                'Job ID': report.job_id,
                'Job Title': report.job_title,
                Type: report.type,
                'Date & Time': report.date_time,
                'Recruiter Name': report.userid
            }));
            const worksheet = xlsx.utils.json_to_sheet(formattedData);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, selectedReports.length > 0 ? 'selected_pipeline_report' : 'pipeline_report');
            if (selectedReports.length === 0 && toast.current) {
                toast.current.show({
                    severity: 'info',
                    summary: 'Info',
                    detail: 'No rows selected, exporting all data.',
                    life: 3000
                });
            }
        }).catch((error) => {
            console.error('Error exporting to Excel:', error);
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'An error occurred while exporting to Excel.',
                    life: 4000
                });
            }
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], { type: EXCEL_TYPE });
        saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    };

    const printFile = () => {
        const exportColumns = [
            { title: "Candidate", dataKey: "candidate" },
            { title: "Job ID", dataKey: "job_id" },
            { title: "Job Title", dataKey: "job_title" },
            { title: "Type", dataKey: "type" },
            { title: "Date & Time", dataKey: "date_time" },
            { title: "Recruiter Name", dataKey: "userid" }
        ];

        const dataToExport = selectedReports.length > 0 ? selectedReports : reports;
        
        if (selectedReports.length === 0 && toast.current) {
            toast.current.show({
                severity: 'info',
                summary: 'Info',
                detail: 'No rows selected, printing all data.',
                life: 3000
            });
        }

        const tableHeaders = exportColumns
            .map(col => `<th style="border: 1px solid #ccc; padding: 10px; background-color: #f5f5f5; font-weight: bold;">${col.title}</th>`)
            .join('');

        const tableRows = dataToExport.length > 0
            ? dataToExport
                .map(row => {
                    if (!row) return '';
                    return `<tr>${exportColumns
                        .map(col => `<td style="border: 1px solid #ccc; padding: 10px;">${row[col.dataKey] ?? '-'}</td>`)
                        .join('')}</tr>`;
                })
                .filter(row => row)
                .join('')
            : '<tr><td colspan="6" style="border: 1px solid #ccc; padding: 10px; text-align: center;">No data available</td></tr>';

        const timestamp = new Date().toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });

        const htmlContent = `
            <html>
            <head>
                <title>Pipeline Report - ${timestamp}</title>
                <style>
                    body {
                        font-family: Arial, sans-serif;
                        margin: 2cm;
                    }
                    table {
                        border-collapse: collapse;
                        width: 100%;
                        margin-top: 20px;
                    }
                    th, td {
                        border: 1px solid #ccc;
                        padding: 12px;
                        text-align: left;
                        font-size: 14px;
                    }
                    th {
                        background-color: #e6e6e6;
                        color: #333;
                    }
                    h2 {
                        text-align: center;
                        font-size: 20px;
                        margin-bottom: 20px;
                        color: #333;
                    }
                    @media print {
                        body {
                            margin: 1cm;
                        }
                        table {
                            page-break-inside: auto;
                        }
                        tr {
                            page-break-inside: avoid;
                            page-break-after: auto;
                        }
                    }
                </style>
            </head>
            <body>
                <h2>Pipeline Report - ${timestamp}</h2>
                <table>
                    <thead><tr>${tableHeaders}</tr></thead>
                    <tbody>${tableRows}</tbody>
                </table>
            </body>
            </html>
        `;

        try {
            const printWindow = window.open('', '_blank', 'height=600,width=900');
            if (!printWindow) {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to open print window. Please allow pop-ups.',
                        life: 4000
                    });
                }
                return;
            }
            printWindow.document.write(htmlContent);
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            setTimeout(() => printWindow.close(), 500);
        } catch (error) {
            console.error('Error during printing:', error);
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'An error occurred while printing.',
                    life: 4000
                });
            }
        }
    };

    return (
        <React.Fragment>
            <div className="page-content allact-tabs">
                <Container fluid={true}>
                    <div className="page-title-box actjobbread">
                        <Row className="align-items-center actjobsum">
                            <Col sm={6} md={6} lg={8}>
                                <h1 className="page-title">My Pipeline Report</h1>
                            </Col>
                            <Col sm={6} md={6} lg={4}>
                                <div className="allbtns d-flex gap-2 justify-content-end">
                                    <Button 
                                        type="button" 
                                        icon="pi pi-file" 
                                        rounded 
                                        onClick={exportCSV} 
                                        tooltip={selectedReports.length > 0 ? "Export Selected to CSV" : "Export All to CSV"} 
                                        tooltipOptions={{ position: 'left' }} 
                                        className="csvbtn" 
                                    />
                                    <Button 
                                        type="button" 
                                        icon="pi pi-file-excel" 
                                        severity="success" 
                                        rounded 
                                        onClick={exportExcel} 
                                        tooltip={selectedReports.length > 0 ? "Export Selected to XLS" : "Export All to XLS"} 
                                        tooltipOptions={{ position: 'top' }} 
                                        className="xlsbtn"
                                    />
                                    <Button 
                                        type="button" 
                                        icon="pi pi-file-pdf" 
                                        severity="warning" 
                                        rounded 
                                        onClick={exportPdf} 
                                        tooltip={selectedReports.length > 0 ? "Export Selected to PDF" : "Export All to PDF"} 
                                        tooltipOptions={{ position: 'bottom' }} 
                                        className="pdfbtn" 
                                    />
                                    <Button 
                                        type="button" 
                                        icon="pi pi-print" 
                                        severity="warning" 
                                        rounded 
                                        onClick={printFile} 
                                        tooltip={selectedReports.length > 0 ? "Print Selected" : "Print All"} 
                                        tooltipOptions={{ position: 'bottom' }} 
                                        className="printbtn" 
                                    />
                                </div>
                            </Col>
                        </Row>

                       
                        <Row>
                            <Col xxl={6}>
                                <h1 className="page-title mb-4"> </h1>
                            </Col>
                            <Col xxl={6}>
                                <div className="d-flex justify-content-end mt-2">
                                    <label className="mt-2 me-2">Select Company</label>
                                    <div className="mb-2 me-2" style={{ width: "170px" }}>
                                        <CompanySelector onCompanyChange={handleCompanyChange} />
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12}>
                                <section className="job-datatable-section">
                                    <div className="card1 mt-3 mb-4 actjobsumtable">
                                            <Toast ref={toast} />
                                        {loading ? (
                                            <OrgTableShimmer columns={6} rows={7} titleWidth="220px" />
                                        ) : (  
                                            <DataTable
                                                ref={dt}
                                                value={reports}
                                                tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                                                rows={rows}
                                                first={first}
                                                paginator
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                onPage={onPage}
                                                dataKey="job_candidate_id"
                                                filters={filters}
                                                filterDisplay="row"
                                                loading={loading}
                                                globalFilterFields={['candidate', 'job_id', 'job_title', 'type', 'date_time', 'userid']}
                                                selection={selectedReports}
                                                onSelectionChange={onSelectionChange}
                                                selectionMode="checkbox"
                                                showGridlines
                                                responsiveLayout="scroll"
                                                columnResizeMode="expand"
                                                resizableColumns
                                                id="MyPipelineReportTable"
                                            >
                                            {/* <Column selectionMode="multiple" style={{ width: '3em' }} /> */}
    <Column field="candidate" sortable header="Candidate" filter filterPlaceholder="Candidate" />
    <Column field="job_id" sortable header="Job ID" filter filterPlaceholder="Job ID" />
    <Column field="job_title" sortable header="Job Title" filter filterPlaceholder="Job Title" className="wrap-word-column" />
    <Column field="type" sortable header="Type" filter filterPlaceholder="Type" />
    <Column field="date_time" sortable header="Date & Time" filter filterPlaceholder="Date & Time" />
    <Column field="userid" sortable header="Recruiter Name" filter filterPlaceholder="Recruiter Name" />
                                            </DataTable>
                                        )}
                                    </div>
                                </section>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default MyPipelineReport;
